import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { humanizeName } from "../utils/rateConcepts";

export default function ItemModal({
  show,
  concepts,
  conditions,
  initialValue,
  onClose,
  onSave,
}) {
  const [form, setForm] = useState({
    concept_id: "",
    value_cents: "",
    condition_group_id: null,
    meta: {},
  });

  useEffect(() => {
    if (initialValue) {
      setForm(initialValue);
    }
  }, [initialValue]);

  const concept = concepts.find(
    (c) => c.id === Number(form.concept_id)
  );

  const isValid =
    form.concept_id &&
    Number(form.value_cents) > 0;

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Regla Tarifaria</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Concepto */}
        <Form.Group className="mb-3">
          <Form.Label>Concepto</Form.Label>
          <Form.Select
            disabled={!!initialValue} 
            value={form.concept_id}
            onChange={(e) =>
              setForm({
                ...form,
                concept_id: Number(e.target.value),
              })
            }
          >
            <option value="">Seleccione concepto</option>
            {concepts.map((c) => (
              <option key={c.id} value={c.id}>
                {humanizeName(c.name)}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {concept && (
          <p className="text-muted">
            {humanConceptDescription(concept)}
          </p>
        )}

        {/* Valor */}
        <Form.Group className="mb-3">
          <Form.Label>Valor</Form.Label>
          <Form.Control
            type="number"
            min={1}
            placeholder="$ Valor"
            value={form.value_cents ? form.value_cents / 100 : ""}
            onChange={(e) => {
              const pesos = Number(e.target.value || 0);

              setForm({
                ...form,
                value_cents: pesos * 100,
              });
            }}
          />
        </Form.Group>

        {concept?.unit_qty && (
          <small className="text-muted">
            Este valor se cobra por cada {concept.unit_qty}{" "}
            {concept.unit}
          </small>
        )}

        {/* Condición */}
        <Form.Group className="mt-3">
          <Form.Label>Asociar condición</Form.Label>
          <Form.Select
            value={form.condition_group_id ?? ""}
            onChange={(e) =>
              setForm({
                ...form,
                condition_group_id: e.target.value ? Number(e.target.value) : null,
              })
            }
          >
            <option value="">Sin Condición</option>
            {conditions.map((c) => (
              <option key={c.id} value={c.id}>
                {humanizeName(c.name)}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="primary"
          disabled={!isValid}
          onClick={() => onSave(form)}
        >
          Guardar regla
        </Button>
      </Modal.Footer>
    </Modal>
  );
}


function humanConceptDescription(concept) {
  switch (concept.calc_kind) {
    case "BASE":
      return "Se cobra una sola vez al iniciar el viaje.";
    case "INCREMENT_PER_UNIT":
      return "Se cobra de forma incremental durante el recorrido.";
    case "ONE_TIME_SURCHARGE":
      return "Recargo único.";
    case "HOURLY":
      return "Se cobra por tiempo transcurrido.";
    case "MINIMUM_FARE":
      return "Asegura un valor mínimo total.";
    default:
      return "";
  }
}
